"use client";
import { getCdnUrl } from "@/services";
import DownloadIcon from "@mui/icons-material/Download";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import { useParams } from "next/navigation";
import { useState } from "react";

export default function MenuDownloadLink() {
  const params = useParams<{ bookId: string; gameSystemId: string }>();
  const { bookId, gameSystemId } = params;
  const [isLoading, setIsLoading] = useState(false);
  if (!bookId || !gameSystemId || gameSystemId === "1") return null;

  const pdfUrl = `/api/army-books/${bookId}/pdf?gameSystem=${gameSystemId}`;

  const handleDownload = async () => {
    if (isLoading) return;

    setIsLoading(true);
    try {
      const response = await fetch(pdfUrl);
      if (!response.ok) throw new Error("Failed to download PDF");

      const data = await response.json();
      debugger;
      console.log(data);

      // const blob = await response.blob();
      // const objectUrl = URL.createObjectURL(blob);
      // const contentDisposition = response.headers.get("content-disposition");
      // const filenameMatch = contentDisposition?.match(/filename\*?=(?:UTF-8''|")?([^";]+)/i);
      // const filename = decodeURIComponent(filenameMatch?.[1] || `army-book-${bookId}.pdf`);

      const link = document.createElement("a");
      link.href = getCdnUrl(data.pdfPath);
      link.download = data.pdfFileName;
      document.body.appendChild(link);
      link.click();
      link.remove();
      //URL.revokeObjectURL(objectUrl);
    } catch {
      window.location.assign(pdfUrl);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Button
      variant="text"
      color="inherit"
      title="Download PDF"
      aria-label="Download PDF"
      onClick={handleDownload}
      disabled={isLoading}
    >
      {isLoading ? <CircularProgress color="inherit" size={20} /> : <DownloadIcon />}
    </Button>
  );
}
